import { RootState } from '../../../../../init-store';
import { isMessengerIntegration } from '../../../../shared/features/config/selectors';
import { selectIsTestplane } from '../../../../shared/features/flags/selectors';

export const selectIsReportAProblemAvailable = (state: RootState) => {
    const isReportAProblemAvailable = Boolean(
        state.call.conference.config?.client_configuration?.report_problem_button_available
    );
    const isMessenger = isMessengerIntegration(state);
    const isTestplane = selectIsTestplane(state);

    return isReportAProblemAvailable && !isMessenger && !isTestplane;
};
